import { useSelector } from "react-redux";
import { handleOnChange as handleInputOnChange } from "../../../../actions/productSpecification";
import toastMessageActions from "jd-library/toastMessageActions";


export const handleOnChange = ({e, parentIndex, item, key = "value",isSellOnline, ignoreValidation = false}) => {
    return (dispatch,getState) => {
        const session = getState().session;
        e.persist && e.persist();
        const value = e.target.value; 
        const {attributeValid, errorMessage} = validation(value, {...item,ignoreValidation});
        const error = errorMessage ? key !== 'value' ? { textboxError: errorMessage} : { error : errorMessage} : {error: "", textboxError: ""};
        const newItem = {
            ...item,
            aiSpec: false,
            userInput: {
                ...item.userInput,
                [key] : value,
                ...error
            }
        }
    
        if(!attributeValid && !!errorMessage ){
    
            dispatch(toastMessageActions.showMessage({message: errorMessage, type : "info",bottom: session.hasGlassFooter ? '80px' : '0px',}));
        }
    
        dispatch(handleInputOnChange({item: newItem, parentIndex}))
    }
} 

export function handleCheckBoxOnChange({data, parentIndex, item, key = "value"}, dispatch){
    let isHiddenPresentAndActive = typeof data !== "string" && data.some(i => (i.label.includes("Other") && i.checked));
    const newItem = {
        ...item,
        textBoxIsHidden: isHiddenPresentAndActive,
        aiSpec: false,
        userInput: {
            ...item.userInput,
            [key] : data,
        }
    }

    if(!isHiddenPresentAndActive && newItem.userInput.hasOwnProperty("textboxValue") && item.isDependentTextBox){
        newItem.userInput.textboxValue = "";
        newItem.userInput.textboxError = "";
    }

    dispatch(handleInputOnChange({item: newItem, parentIndex}))
}

export function handleOnDropdownChange({value, parentIndex, item, key="value"}, dispatch){
    let isHiddenPresentAndActive = value.includes("Other");
    const dropdownError  = key == 'textboxValue' ? {textboxError: ""} : {};
    const newItem = {
        ...item,
        aiSpec: false,
        textBoxIsHidden: isHiddenPresentAndActive,
        userInput: {
            ...item.userInput,
            ...dropdownError,
            [key] : value
        }
    }

    if(!isHiddenPresentAndActive && newItem.userInput.hasOwnProperty("textboxValue") && item.isDependentTextBox){
        newItem.userInput.textboxValue = "";
        newItem.userInput.textboxError = "";
    }
    if(newItem.userInput?.value && newItem.s_subType != 'UnitboxWithDropdown'){
         newItem.userInput.error = "";
    }

    dispatch(handleInputOnChange({item: newItem, parentIndex}));
}

export const handleOnBlur = ({e, item, parentIndex, key="textboxError", isDependentTextBox}) => {
    return (dispatch,getState) => {
        const session = getState().session;
        const value = e.target.value;
        const errorMessage = item.userInput.error || item.userInput.textboxError || (!value && isDependentTextBox ? "Enter Other Details" : !value ? "Enter Value" : "");
        const newItem = {
            ...item,
            userInput:{
                ...item.userInput,
                [key]: errorMessage
            }
        }
        
        if(!value){
            dispatch(toastMessageActions.showMessage({message: `Please ${errorMessage}`, type:"info",bottom: session.hasGlassFooter ? '80px' : '0px'}));
        }
        dispatch(handleInputOnChange({item:newItem, parentIndex}));
    }
}

function checkRegex(reg) {
    let iterator = Math.random().toString().substring(2,3);
    let count = 0;
    while(reg.test(iterator.toString())) {
        count++;
        iterator = Math.random().toString().substring(2,2+count+1);
    }
    return count;
}
export function validation(value, {s_regexp, s_mandatory, userInput, s_type, ignoreValidation = false},isSellOnline){
    const ERRORS = {
        required: "This specification is mandatory"
    }
    let attributeValid = true;

    let regexp = s_regexp;
    let customMessage = "Only";
    
    if(regexp && value){
        regexp = regexp.replace(/^\/|\/$/g, ''); // for removing extra slash
        const reg = new RegExp(regexp);
         
        if(!reg.test(value.trim())){
            if(reg.test('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ')){
                customMessage +=  " alphabets and";
            }
            if(reg.test('0123456789')){
                customMessage +=  " numbers and";
            }
            if(reg.test('!@#$%&*(){}^')){
                customMessage +=  " special characters and";
            }
            if(reg.test(' ')){
                customMessage +=  " space and";
            }
            if(customMessage.length == 4){
                let digitCount = checkRegex(reg);
                customMessage += digitCount > 1 ?" "+digitCount+" digit numbers and":"";
            }
            customMessage = customMessage.substring(0, customMessage.length-3);
            customMessage += "are allowed";
            attributeValid = false;
            return {attributeValid, errorMessage: customMessage};
        }
    }
    if(Number(s_mandatory) && isSellOnline){
        if(
            (
                (	s_type == 'Textbox' || 
                    s_type == 'TextArea' || 
                    s_type == 'TextBoxAutosuggest'
                ) && !value
            ) ||
            (	["CheckBoxAutosuggest", "Checkbox"].includes(s_type) && !userInput.value.some((obj) =>  obj.checked)
            ) ||
            (	s_type == 'Dropdown' && !userInput.value
            )
        ){
            attributeValid = false; 
            return {
                errorMessage: ignoreValidation ? '' : ERRORS.required,
                attributeValid        
            }
        }
    }
    
    return {
        errorMessage: "",
        attributeValid
    }
}

const validatationLabel = (label, value, type = "") => {
    let isInvalid = false;
    if(type && ['checkbox','dropdown','dropdownautosuggest','textbox','textarea','textboxautosuggest'].includes(type)){
        const newValue = value.replace(/\s+/g, ' ');
        const wordsToChck = newValue.split(" ");
        const cond1 = ['other','others'].includes(wordsToChck[0]);
        const cond2 = label.split(" ").toString() == wordsToChck.toString();
        const reg = /^\s*0(\s*0)*\s*$/;
        if(cond1){
            const tmpAry = newValue.split(' ')
            if(tmpAry.length == 1 || tmpAry.slice(1).toString() == label.split(" ").toString()){
                isInvalid = true;
            }
        }else if(wordsToChck?.length == label.split(' ')?.length && cond2){
            isInvalid = true;
        }else if(newValue && (reg.test(newValue) || ['zero','zeros'].includes(newValue.toLowerCase()))) {
            isInvalid = true;
        }
    }
    return isInvalid;
}

export function validateAndUpdate({ editablePuvSpecAttributes, initCustomSpecAttributes, contentWeightUnit, productOrService, showSellOnline, isEnrichSpec, viaOmni = false, isAuditor = false }, callback) {
    const ERRORS = {
        INPUT : "Enter Value",
        SELECT: "Select Value",
    }

    let cusData = JSON.parse(JSON.stringify(initCustomSpecAttributes));
    const specData = JSON.parse(JSON.stringify(editablePuvSpecAttributes));

    let isValidForm = true;  
    if(specData.length){ 
        specData.forEach((item) => {

            switch(item.s_type.toLowerCase()){
                case "textbox":
                    if(!!item.s_subType && item.s_unit.length > 1){
                        if(!!item.userInput.value && !item.userInput.textboxValue){
                            item.userInput.textboxError = ERRORS.SELECT;
                            isValidForm = false;
                        }

                        if(!!item.userInput.textboxValue && !item.userInput.value){
                            item.userInput.error = ERRORS.INPUT;
                            isValidForm = false;
                        }
                    }
                    break;
                case "rangebox":
                    if(!!item.userInput.value && !item.userInput.textboxValue){
                        item.userInput.textboxError = ERRORS.INPUT;
                        isValidForm = false;
                    }

                    if(!!item.userInput.textboxValue && !item.userInput.value){
                        item.userInput.error = ERRORS.INPUT;
                        isValidForm = false;
                    }
                    break;
                case "dropdown":
                    if(
                        item.userInput.value &&
                        item.s_type_options.some(i => i.toLowerCase().includes('other')) && 
                        item.userInput.value.toLowerCase().includes('other') && 
                        item.userInput.hasOwnProperty("textboxValue") && 
                        !item.userInput.textboxValue.trim()
                    ){
                        item.userInput.textboxError = ERRORS.INPUT;
                        if(item?.textBoxIsHidden){
                            item.userInput.textboxError = 'Enter Other Details';
                        }
                        isValidForm = false;
                    }
                break; 
                case "checkbox": 
                    if(
                        item.userInput.value &&
                        item.s_type_options.some(i => i.toLowerCase().includes('other')) && 
                        item.userInput.value.some(i => i.label.toLowerCase().includes('other') && i.checked) &&
                        item.userInput.hasOwnProperty("textboxValue") && 
                        !item.userInput.textboxValue.trim()
                    ){
                        item.userInput.textboxError = ERRORS.INPUT;
                        if(item?.textBoxIsHidden){
                            item.userInput.textboxError = 'Enter Other Details';
                        }
                        isValidForm = false;
                    }
                break; 
            }
        });
    }

    if(cusData.length){
        let keyNameObj = {};
        cusData = cusData.filter((item) => {
            if(!!item.key.value && !item.value.value){
                item.value.error = ERRORS.INPUT;
                isValidForm = false;
            }

            if(!!item.value.value && !item.key.value){
                item.key.error = ERRORS.INPUT;
                isValidForm = false;
            }
            if(item.key.value && item.value.value && ['other','others'].includes(item.value.value.toLowerCase().trim())){
                item.value.error = ' ';
                isValidForm = false;
            }
            if(isValidForm && item.key.value && item.value.value) {
                if(keyNameObj[item.key.value.toLowerCase().trim()]){
                    item.key.error = 'Duplicate Specification';
                    isValidForm = false;
                }else {
                    keyNameObj[item.key.value.toLowerCase().trim()] = item.value.value;
                }
            }
            if(!item.key.value && !item.value.value) {
                return false;
            }else {
                return item;
            }
        })
    }

    const ignoreField = ['brand','country_of_origin','price','manufacturer','manufactured_details','importer','importers_detail','packaging_length','packaging_width','packaging_height','packaging_weight','expiry_date'];
    let error = "";
    for(const item of specData){
        if ((showSellOnline || productOrService == 'service' ? Number(item.s_mandatory) : Number(item.s_re_mandatory)) && !(typeof item.userInput?.value === 'string' ? item.userInput?.value?.trim() : item.userInput?.value) && ((!ignoreField.includes(item.s_nm.toLowerCase()) && item.s_type != 'Fixed' && !viaOmni && !isAuditor) || isEnrichSpec)) {
            item.userInput.error = 'Required Field';
            error = error ? error : 'Please Enter Required Fields';
            isValidForm = false;
        }
        if(["textbox", 'textarea', "rangebox", "dropdown", 'checkbox','dropdownautosuggest','textboxautosuggest'].includes(item.s_type.toLowerCase())){
            const prefix = !['alphabet', 'number', 'special', 'space'].some( e => item.userInput.error.toLowerCase().includes(e)) ? "Please": "";
            if(!!item.userInput.error){
                const checkInitWordPlease = item.userInput.error.split(" ")[0].toLowerCase() == "please"
                error = error ? error : checkInitWordPlease ? item.userInput.error : `${prefix} ${item.userInput.error}`;
                isValidForm = false;
            }

            if(item.hasOwnProperty("s_subType")){
                if(!!item.userInput.textboxError){
                    const checkInitWordPlease = item.userInput.textboxError.split(" ")[0].toLowerCase() == "please"
                    error = error ? error : checkInitWordPlease ? item.userInput.textboxError : `${prefix} ${item.userInput.textboxError}`;
                    isValidForm = false;
                }
            }

            if(item.userInput.hasOwnProperty("textboxError") && !!item.userInput.textboxError){
                const checkInitWordPlease = item.userInput.textboxError.split(" ")[0].toLowerCase() == "please"
                error = error ? error : checkInitWordPlease ? item.userInput.textboxError : `${prefix} ${item.userInput.textboxError}`;
                isValidForm = false;
            }
            
            if (item.s_type == "Checkbox"){
                if ((showSellOnline || productOrService == 'service' ? Number(item.s_mandatory) : Number(item.s_re_mandatory)) && ((!ignoreField.includes(item.s_nm.toLowerCase()) && item.s_type != 'Fixed' && !viaOmni) || isEnrichSpec) && !isAuditor) {
                    const isChecked =  item.userInput?.value &&  item.userInput?.value?.some(x => x.checked);
                    if (!isChecked){
                        item.userInput.error = 'Required Field';
                        error = error ? error : 'Please Enter Required Fields';
                        isValidForm = false;
                    }else {
                        error = ""
                        item.userInput.error = ""
                        isValidForm = true
                    }
                }
                if (item.userInput?.value && item?.s_type_options?.includes("Others")  && !item?.userInput?.textboxValue){
                    if(item.userInput?.value?.some(x => x?.label == "Others" && x?.checked)){
                        error = error ? error : 'Please Enter Required Fields';
                        isValidForm = false;
                    }

                }
            }

            const valueToCompare = item.userInput?.textboxValue && item.s_unit[0] != item.userInput.textboxValue ? item.userInput?.textboxValue : typeof item.userInput?.value === 'string' && item.userInput?.value || ""
            const isInvalidLabel = validatationLabel(item.s_dnm?.toLowerCase().trim(), valueToCompare?.toLowerCase().trim(), item.s_type.toLowerCase())
            if (["checkbox", "dropdown", "dropdownautosuggest"].includes(item.s_type.toLowerCase())) {
                if ((typeof item.userInput?.value === 'string' ? item.userInput?.value.toLowerCase().includes("other") : true) && isInvalidLabel) {
                    let err = `Please enter valid ${item.s_dnm}`;
                    item.userInput.textboxError = err;
                    error = error ? error : err
                    isValidForm = false;
                }
            } else if (isInvalidLabel) {
                let err = `Please enter valid ${item.s_dnm}`;
                item.userInput.error = err;
                error = error ? error : err
                isValidForm = false;
            }
        }
    }
    
    if(!contentWeightUnit.contentPerPiece.value.length && contentWeightUnit.unitPerPiece.value.length){
        contentWeightUnit.contentPerPiece.error = ERRORS.INPUT;
        error = `Please ${ERRORS.INPUT}`
        isValidForm = false;
    }

    if(!contentWeightUnit.unitPerPiece.value.length && contentWeightUnit.contentPerPiece.value.length){
        contentWeightUnit.unitPerPiece.error = ERRORS.SELECT;
        error = `Please ${ERRORS.SELECT}`
        isValidForm = false;
    }

    if(!error){
        for(const c_item of cusData){
            // this for custom spec
            const tmpLabel = c_item.key?.value?.toLowerCase().trim() || ""
            const tmpValue = c_item?.value?.value?.toLowerCase().trim() || ""
            const isInvalidLabel = validatationLabel(tmpLabel, tmpValue, "textbox")
            if (tmpLabel !== "" && tmpValue !== "" && isInvalidLabel){
                error = `Please enter valid ${c_item.key.value}`;
                c_item.value.error = error;
                isValidForm = false;
                break;
            }else if(!!c_item.value.error && !['other','others'].includes(c_item?.value?.value?.toLowerCase().trim())){
                error = "Please Enter Specification Value";
                isValidForm = false;
                break; 
            }else if(!!c_item.key.error && c_item.key.error == ERRORS.INPUT){
                error = "Please Enter Specification Option";
                isValidForm = false;
                break;
            }else if(!!c_item.key.error && c_item.key.error.toLowerCase() == 'duplicate specification') {
                error = "Duplicate Specification - "+c_item.key.value;
                isValidForm = false;
                break;
            }
            else if (['other','others'].includes(c_item?.value?.value?.toLowerCase().trim())){
                error = `Please Enter Valid ${c_item.key.value}`;
                isValidForm = false;
                break;
            }
        }
    } 

    callback && callback({
        initCustomSpecAttributes:cusData,
        editablePuvSpecAttributes : specData,
        contentWeightUnit,
        isValidForm,
        error
    })
}

export function getAllSpecificationData(savedPuvSpecAttributes,savedCustomSpecAttributes,fromCountry){
    const specification = [];
    savedPuvSpecAttributes.map((item) => {
        if(item.userInput.value && ["checkbox", "checkboxautosuggest"].includes(item.s_type.toLowerCase())){
            const obj = {
                sid: item.s_id,
                s_filter_flag: item.s_filter_flag,
                name: item.s_dnm,
                s_name: item.s_nm,
                values: Array.isArray(item.userInput.value) ? item.userInput.value.reduce((acc, s) => {
                    if(s.checked && !s.label.toLowerCase().includes('other')){
                        acc.push(s.label);
                    }
                    return acc;
                }, []) : item.userInput.value,
                unit: "",
                aiSpec: item.aiSpec || false
            }

            if(!!item.userInput.textboxValue){
                    obj.values.push(item.userInput.textboxValue);
            }
            specification.push(obj);
        } 
        let arr = ['rangebox', "dropdown",'textbox', 'textarea', 'textboxautosuggest', 'fixed','dropdownautosuggest','date'];
        let ignoreOther = ["dropdown","dropdownautosuggest"];
        let hasOtherOption = item?.s_type_options?.length ?  item?.s_type_options?.find(ele => ele.toString().toLowerCase().includes('other')) : false;
        if(fromCountry){
            arr.push('fixed')
        }
        if(arr.includes(item.s_type.toLowerCase())){
            let obj = {}
            if(item.userInput.value || item.s_type == 'Fixed' || (fromCountry && item.s_nm == 'country_of_origin' && item.s_type?.toLowerCase() == 'fixed' && item?.s_type_options[0])){
                obj = {
                    sid: item.s_id,
                    name: item.s_dnm,
                    s_name: item.s_nm,
                    s_filter_flag: item.s_filter_flag,
                    values: item.userInput.value && typeof item.userInput.value === 'string'  ? item.userInput.value.split() : (item.s_nm == 'country_of_origin' || item.s_type == 'Fixed') && item.s_type_options && item.s_type_options[0] ? item.s_type_options[0] : '',
                    unit: item.s_subType && item.userInput.textboxValue ? item.userInput.textboxValue : item.s_unit?.length == 1 && (item.s_unit_pos == '0' || item.s_unit_pos == '1') ? item.s_unit[0] : '',
                    aiSpec: item.aiSpec || false
                }
                if(!item.s_subType && item.userInput.textboxValue){
                    if(hasOtherOption && ignoreOther.includes(item.s_type.toLowerCase())) {
                        obj.values = [item.userInput.textboxValue];
                    }else {
                        obj.values.push(item.userInput.textboxValue);
                    }
                } 
                if(['packaging_weight','packaging_width','packaging_height','packaging_length'].includes(item.s_nm)) {
                    obj.unit = item.userInput.sunit ? item.userInput.sunit : '';
                }
                specification.push(obj);
            }
        } 
    }); 

    savedCustomSpecAttributes.map((item) => {
        if(item.key.value && item.value.value){
            specification.push({
                sid: "",
                values: item.value.value.split(),
                name: item.key.value,
                unit: "",
                s_filter_flag:"",
                isCustom: 1
            });
        }
    })

    return specification;
}